import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

const articleImages: Record<string, string> = {
  "article-rumen": "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20laptop%20and%20notebook%20on%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20warm%20cream%20tones%2C%20editorial%20photography%20style%2C%20organic%20composition%20with%20plants&width=800&height=450&seq=article-rumen&orientation=landscape",
  "article-yinqing": "https://readdy.ai/api/search-image?query=Multiple%20computer%20screens%20displaying%20search%20results%20in%20a%20modern%20office%2C%20warm%20ambient%20lighting%2C%20minimalist%20tech%20workspace%2C%20professional%20atmosphere%2C%20clean%20composition&width=800&height=450&seq=article-yinqing&orientation=landscape",
  "article-anquan": "https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20shield%20and%20lock%20icons%20on%20a%20warm%20creamy%20background%2C%20minimalist%20design%2C%20soft%20gradient%20lighting%2C%20professional%20cybersecurity%20aesthetic&width=800&height=450&seq=article-anquan&orientation=landscape",
  "article-jiqiao": "https://readdy.ai/api/search-image?query=Person%20typing%20on%20keyboard%20with%20magnifying%20glass%20icon%20floating%2C%20warm%20workspace%20with%20coffee%2C%20minimalist%20desk%20setup%2C%20soft%20natural%20light%2C%20clean%20aesthetic&width=800&height=450&seq=article-jiqiao&orientation=landscape",
  "article-gongju": "https://readdy.ai/api/search-image?query=Modern%20software%20interface%20design%20on%20monitor%20screen%2C%20clean%20UI%20layout%2C%20warm%20ambient%20office%20lighting%2C%20minimalist%20desk%20with%20plants%2C%20professional%20work%20environment&width=800&height=450&seq=article-gongju&orientation=landscape",
  "article-dianzishu": "https://readdy.ai/api/search-image?query=Elegant%20bookshelf%20with%20organized%20books%20and%20an%20e-reader%20device%2C%20warm%20reading%20nook%20with%20soft%20lamp%20light%2C%20cozy%20minimalist%20interior%2C%20cream%20and%20wood%20tones&width=800&height=450&seq=article-dianzishu&orientation=landscape",
  "article-yingshi": "https://readdy.ai/api/search-image?query=Home%20theater%20setup%20with%20large%20TV%20screen%20displaying%20movie%20interface%2C%20cozy%20living%20room%20with%20warm%20ambient%20lighting%2C%20minimalist%20entertainment%20space%2C%20cinematic%20atmosphere&width=800&height=450&seq=article-yingshi&orientation=landscape",
  "article-jiexi": "https://readdy.ai/api/search-image?query=Abstract%20digital%20network%20nodes%20connected%20by%20lines%20on%20warm%20beige%20background%2C%20minimalist%20tech%20concept%2C%20soft%20gradient%2C%20clean%20modern%20design%20aesthetic&width=800&height=450&seq=article-jiexi&orientation=landscape",
};

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const imageUrl = articleImages[article.imageSeq] || articleImages["article-rumen"];

  const categoryLabel =
    article.category === "yingshi"
      ? "影视资源"
      : article.category === "ruanjian"
        ? "软件资源"
        : article.category === "wendang"
          ? "文档资源"
          : article.category === "yinyue"
            ? "音乐资源"
            : article.category === "youxi"
              ? "游戏资源"
              : "其他资源";

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/70 transition-all duration-300"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={imageUrl}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs text-accent-600 bg-accent-100/80 px-2.5 py-0.5 rounded-full font-medium whitespace-nowrap">
            {categoryLabel}
          </span>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
        </div>
        <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/60">
          <span className="text-xs text-foreground-400">{article.date}</span>
          <span className="text-xs text-primary-500 font-medium flex items-center gap-1 group-hover:gap-2 transition-all duration-200">
            阅读全文
            <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}